import React, { useState } from 'react';
import {Button, Collapse, Input, message, Typography} from 'antd';
import { BulbOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

const { TextArea } = Input;

const {Panel} = Collapse;

const JsonViewer: React.FC = () => {
    const [jsonString, setJsonString] = useState<string>('');
    const [hierarchicalKey, setHierarchicalKey] = useState<string>('');
    const [parsedJson, setParsedJson] = useState<any>(null);

    const handleJsonChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setJsonString(event.target.value);
    };

    const handleElementClick = (path: string) => {
        setHierarchicalKey(path);
    };

    const handleParseJson = () => {
        try {
            const parsed = JSON.parse(jsonString);
            setParsedJson(parsed);
            setHierarchicalKey(''); // Reset the selected key
            message.success('JSON erfolgreich geparst!');
        } catch (error) {
            message.error('Ungültiges JSON-Format. Bitte überprüfen Sie den JSON-String.');
        }
    };

    const renderTree = (data: any, path: string) => {
        return Object.keys(data).map(key => {
            const value = data[key];
            const type = typeof value;
            const isObject = type === 'object' && value !== null;
            const newPath = path ? `${path}.${key}` : key;
            const handleClick = () => handleElementClick(newPath);

            return (
                <div key={key} style={{ marginLeft: '20px' }}>
                    <span style={{ cursor: 'pointer' }} onClick={handleClick}>
                        {JSON.stringify(key)}:
                    </span>
                    {isObject
                        ? renderTree(value, newPath)
                        : <span style={{ cursor: 'pointer' }} onClick={handleClick}>{JSON.stringify(value)}</span>}
                </div>
            );
        });
    };

    // Bedienungsanleitung
    const instructions = [
        "Kopieren Sie ihr JSON-Dokument in das Textfeld.",
        "Klicken Sie auf 'Pfad erstellen'.",
        "Klicken Sie auf das Element im Baum, dessen JSON-Pfad Sie ermitteln möchten."
    ];

    return (
        <div>
            <h1>Json-Pfad</h1>
            {/* Dropdown für die Bedienungsanleitung */}
            {/* Collapsible Panel für die Bedienungsanleitung */}
            <Collapse>
                <Panel header={<span><BulbOutlined style={{ marginRight: 8 }} /> Bedienungsanleitung</span>} key="1">
                    {instructions.map((instruction, index) => (
                        <Paragraph key={index} style={{ margin: 0 }}>
                            {instruction}
                        </Paragraph>
                    ))}
                </Panel>
            </Collapse>
            <TextArea
                style={{marginTop: 10}}
                rows={10}
                value={jsonString}
                onChange={handleJsonChange}
                placeholder="Geben Sie hier den JSON-String ein..."
            />
            <div style={{ marginTop: '10px' }}>
                <Button type="primary" onClick={handleParseJson} style={{ marginRight: '10px' }}>
                    Pfad erstellen
                </Button>
                <Button onClick={() => setHierarchicalKey('')}>Zurücksetzen</Button>
            </div>
            <div style={{ marginTop: '20px', marginLeft: '20px' }}>
                <pre>{parsedJson && renderTree(parsedJson, '')}</pre>
            </div>
            <div>
                <h3>Der vollständige Pfad: {hierarchicalKey}</h3>
            </div>
        </div>
    );
};

export default JsonViewer;
